import defaultSettings from '../../config/defaultSettings';
import { history } from 'umi';
import {
  applyPortalShellBrand,
  clearPortalShellBrand,
} from '@/utils/infrastructure/whiteLabel';

const updateColorWeak = (colorWeak) => {
  const root = document.getElementById('root');

  if (root) {
    root.className = colorWeak ? 'colorWeak' : '';
  }
};

const SettingModel = {
  namespace: 'settings',
  state: defaultSettings,
  effects: {
    *updatePortal(__, { select }) {
      try {
        const portal = yield select(
          (state) => state.companyPortal.portal || history.location?.state,
        );

        // Process portal mark (logo/color/font) owns the shell. Company
        // white-label is restored only when leaving the portal.
        if (portal) {
          applyPortalShellBrand(portal, { updateFavicon: false });
          return;
        }

        clearPortalShellBrand({ updateFavicon: false });
      } catch (e) {}
    },
  },
  reducers: {
    changeSetting(state = defaultSettings, { payload }) {
      const { colorWeak, contentWidth } = payload;

      if (state.contentWidth !== contentWidth && window.dispatchEvent) {
        window.dispatchEvent(new Event('resize'));
      }

      updateColorWeak(!!colorWeak);
      return { ...state, ...payload };
    },
  },
};
export default SettingModel;
